import ApiUtils from '../../../helpers/ApiUtils'
import ProjectImportsApi from '../../../apis/ProjectImportsApi'

const fetchAll = (projectId, page = null) => (
  new ProjectImportsApi(projectId).get({
    query: {
      page
    }
  }).then(ApiUtils.handleResponse)
)

export default {
  fetchAll
}
